import React, { useState } from "react";
import { api } from "../../lib/api";
import { apiErr } from "../../lib/utils";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";

export default function FundingGateDialog({ iid, gate, open, onClose, onReviewFunding, onResolved }) {
  const [note, setNote] = useState("");
  const [showNote, setShowNote] = useState(false);
  const [busy, setBusy] = useState(false);

  const resolve = async (action) => {
    if (action === "management_override" && !note.trim()) {
      setShowNote(true);
      toast.error("A note is required to record a management override");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/susfin/funding-gate/${iid}/resolve`, { action, note: note || null });
      toast.success(action === "management_override" ? "Management override recorded" : "Confirmed — no funding required");
      onResolved?.();
    } catch (e) { toast.error(apiErr(e)); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="sf-gate-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-[#FFB800]" /> {gate?.title || "Funding Gate"}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground" data-testid="sf-gate-message">{gate?.message}</p>
        {showNote && (
          <Input placeholder="Override justification (required)" value={note} onChange={(e) => setNote(e.target.value)} data-testid="sf-gate-note" />
        )}
        <div className="flex flex-col gap-2 mt-2">
          <Button variant="primary" onClick={() => { onClose(); onReviewFunding?.(); }} data-testid="sf-gate-review-funding">
            Review Funding
          </Button>
          <Button variant="outline" disabled={busy} onClick={() => (showNote ? resolve("management_override") : setShowNote(true))} data-testid="sf-gate-override">
            Record Management Override
          </Button>
          <Button variant="outline" disabled={busy} onClick={() => resolve("no_funding_required")} data-testid="sf-gate-no-funding">
            Confirm No Funding Required
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
